var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCopyLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1035_4991)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.575 0.984375C1.24881 0.984375 0.984375 1.24881 0.984375 1.575V8.87031C0.984375 9.1965 1.24881 9.46094 1.575 9.46094H4.53906V12.425C4.53906 12.7512 4.80349 13.0156 5.12969 13.0156H12.425C12.7512 13.0156 13.0156 12.7512 13.0156 12.425V5.12966C13.0156 4.80347 12.7512 4.53904 12.425 4.53904H9.46094V1.575C9.46094 1.24881 9.19651 0.984375 8.87031 0.984375H1.575ZM9.12858 5.19529C9.12999 5.1953 9.1314 5.19531 9.13281 5.19531C9.13422 5.19531 9.13563 5.1953 9.13704 5.19529H12.3594V12.3593H5.19531V9.13281V5.19529H9.12858ZM8.80469 4.53904V1.64062H1.64062V8.80469H4.53906V5.12966C4.53906 4.80347 4.8035 4.53904 5.12969 4.53904H8.80469Z",
    fill: "#9E9E9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1035_4991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopyLined);
export default __webpack_public_path__ + "static/media/ic_copy_lined.493bed72ab3fb0888c86091d9add6763.svg";
export { ForwardRef as ReactComponent };